import { FormGroup, FormControl } from '@angular/forms';
import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { NdmsFormControlComponent } from '../ndms-form-control/ndms-form-control.component';

@Component({
  selector: 'ndms-currency',
  templateUrl: './ndms-currency.component.html',
  styleUrls: ['./ndms-currency.component.scss']
})
export class NdmsCurrencyComponent extends NdmsFormControlComponent implements OnInit {

  @Input() field: string;
  @Input() group: FormGroup;

  @Input() size: string;
  @Input() placeholder: string;

  @Input() label: string;
  @Input() labelHidden: boolean;

  @Input() readonly: boolean;
  @Input() isEditing: () => boolean;

  @Input() required: string;

  constructor(viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);

    // let formControl: FormGroup = (<FormControl>this.group.get(this.field));
    
    // Check for whether max or min exist, add to an array [NdmsValidators.minValue(this.min), maxValue(this.max)]
    // Check for required exists or not, add to the array [required, minvalue, maxvalue]

    // formControl.setValidators(arr)
  }

  ngOnInit() {
  }

  canAddArrayItem(currentIndex: number) {
    return true;
  }

}
